import React, {useEffect, useMemo} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {FormattedMessage} from 'react-intl';

import {IStore} from 'redux/interface';
import {getJournal, getTranslations, journalAsyncActions} from 'redux/pageAsyncActions';
import {useGetTranslations} from 'utils/hooks/useGetTranslations';
import {BotType} from 'utils/hooks/use-chat-bot/interfaces';
import {Pages, TranslationKeys} from 'utils/constants/routeConstants';

import BotChat from 'components/bot-chat';

import {closeArticle} from 'redux/content/actions';
import XpeditionIcon from 'assets/image/menu-auth/xpedition.png';

import './styles.scss';
import {Link, useParams} from 'react-router-dom';
import {BotMode} from '@wholesalechange/chatcomponent';

export const JournalChat: React.FunctionComponent = () => {
  const {
    loading
  } = useSelector((state: IStore) => state.status);
  const {
    journal
  } = useSelector((state: IStore) => state.journal);
  const {
    settings
  } = useSelector((state: IStore) => state.auth);
  const dispatch = useDispatch();
  const {journalId} = useParams();

  useEffect(() => {
    dispatch(closeArticle());
  }, []);

  useEffect(() => {
    if (journalId) {
      dispatch(journalAsyncActions[getJournal](Number(journalId)));
    }
  }, [journalId]);

  const translationKey = useMemo(() => {
    const page = settings?.pages.find((p) => p.name.toLowerCase() === Pages.Journals.toLowerCase());

    return page?.translationKey || TranslationKeys.Journals;
  }, [settings]);

  useGetTranslations({translationKey});

  const title = useMemo(() => {
    const page = settings?.pages.find((p) => p.name.toLowerCase() === Pages.Journals.toLowerCase());

    return page?.title || Pages.Journals;
  }, [settings]);

  function renderBreadcrumbs() {
    return <div className="breadcrumbs">
      <Link className="breadcrumbs__previous" to="/journals">
        <FormattedMessage
          id={`gritx.common.navigation.${title}`}
          defaultMessage={title}
        />
      </Link> {journal && <span className="journal__title-dialogue-name"> - {journal.dialogName}</span>}
    </div>;
  }

  return <div className="journal">
    {
      !loading.includes(getTranslations) && journal && <>
        <h1 className="journal__title">
          <img src={XpeditionIcon} alt="" className="journal__icon"/>
          {renderBreadcrumbs()}
        </h1>
        <BotChat chatType={BotType.Xpedition} chatMode={BotMode.NoHistory} dialogueId={journal.dialogId}
          title={journal.dialogName}
          tabsEnabled={settings?.chatSettings?.tabsEnabled || false}/>
      </>
    }
  </div>;
};
